export default {
  GY: {
    ts: 'Tips',

    qw: 'Go to',
    qr: 'OK',
    qx: 'Cancel',

    hd: "Ok",

    qdl: 'Go to login',
    byl: 'Forget it',
  },
  GYTS: {
    ts0: 'Failed to connect to server',
    xdl: 'This feature requires login to access. Would you like to log in?',
    ts1: 'The feature is under development and will be gradually opened in the later stages.',
    ts2: 'The feature is not enabled yet.',
    ts3: 'No more data',
    ts4: 'Please wait...',
    ts5: 'Loading...',
    ts6: 'Failed to retrieve login information!',
  },
  mvp: {
    ddrttx: 'Understand Body Signals',
    sy: 'Home',
    xhlr: 'Input',
    xhcl: 'Processing',
    csk: 'KB',
    wd: 'Me',
    dl: 'Login',
  },
  SURV: {
    ts1: 'Please carefully read the following precautions',
    jcxx: 'Basic Information',
    mustInputName: 'You must enter your name information',
    mustInputPhone: 'You must enter your contact information',
    mustInputHeartRate: 'You must enter your heart rate, in beats per minute',
    invalidAge: 'Please enter your age in numbers',
    invalidHeight: 'Please enter your height in numbers, in centimeters.',
    invalidWeight: 'Please enter your weight in numbers, in kilograms',
    invalidHeartRate: 'Please enter your heart rate in numbers, in beats per minute',
    registerPrompt: 'Do you want to register as a member? You can query your own file more conveniently',
    goRegister: 'Go to register',
    hasAccount: 'Already have an account',
    goLogin: 'Go to login',
    submitSuccess: 'Submitted successfully. Click OK to view the signal results.',
    submitPreviewFailed: 'Failed to submit preview data',
    submitSuccessMsg: 'Submitted successfully',
    mygw: "You haven't selected a dedicated consultant yet. We'll assign one for you automatically, but you can change it before submitting.",
    mygw2: "You haven't selected a dedicated consultant yet. Tap the button to choose one.",
    modifySuccessMsg: 'Modified successfully',
    registerSuccess: 'Registration successful!',
    loginFailed: 'Login failed',
    name: 'Name',
    qsrName: 'Please enter your name',
    age: 'Age',
    qsrAge: 'Please enter your age',
    contact: 'Contact Information',
    qsrContact: 'Please enter your contact information',
    gender: 'Gender',
    nan: 'Male',
    nv: 'Female',
    height: 'Height (cm)',
    qsrHeight: 'Please enter your height',
    weight: 'Weight (kg)',
    qsrWeight: 'Please enter your weight',
    heartRate: 'Heart Rate (HR)',
    qsrHeartRate: 'Please enter your heart rate',
    occupation: 'Occupation',
    qsrOccupation: 'Please enter your occupation',
    femaleRelated: 'Female-related',
    menstruation: 'Menstruation',
    isPregnant: 'Are you pregnant',
    iAgree: 'I agree',
    clean: 'Clear',
    submit: 'Submit',
    confirmModify: 'Confirm modification',
    returnModify: 'Return to modify',
    confirmSubmit: 'Confirm submission',
    tip: 'Tip',
    continueSubmit: 'Don\'t need either, continue to submit',
    qsr: 'Please enter',
    zztj: 'Submit',
    zzsf: 'Submitting',
    uploadSuccess: 'Upload successful',
    uploadFailed: 'Upload failed',
  },
  SPI: {
    jkzz: 'Health Self-Help',
    jkgw: 'Health Consultant',
    jkgwq: 'Health Consultant, please proceed to'
  },
  KBI: {
    dsi: 'Typical Signal Interpretation',
    bcw: 'Herbal Properties and Indications',
    jfj: 'Compilation of Classical',
  },
  MMT: {
    wdgw: 'My Consultant',
    dlzc: 'Login/Register',
    xgjbxx: 'Modify Basic Information',
    xgmm: 'Change Password',
    xhtxjl: 'Medical visit record',
    yy: 'Language',
    tcdl: 'Logout',
    zztc: 'Logging Out',
    hqgylbsb: 'Failed to Retrieve About List',
    qrtcdlm: 'Are you sure you want to log out?',
  },
  ULV: {
    yhdl: 'User Login',
    zzdl: 'Logging In',
  },
  LF: {
    dlyx: 'Email',
    qsrnddlyx: 'Please enter your login email',
    qsrdlyx: 'Please enter login email',
    qsrzqyxgs: 'Please enter the correct email format',
    dlmm: 'Password',
    qsrmm: 'Please enter password',
    mmcd: 'The minimum password length is 6 characters',
    dl: 'Login',
    myzh: 'No account',
    wjmm: 'Forgot Password',
    zcyx: 'Registration Email',
    qsrzcyx: 'Please enter registration email',
    fsczmmyj: 'Send Password Reset Email',
  },
  URR: {
    yhzc: 'Sign Up',
    zzzc: 'Registering',
  },
  RF: {
    dlyx: 'Email',
    qsrnddlyx: 'Enter your email',
    qsrdlyx: 'Enter email',
    qsrzqyxgs: 'Enter a valid email',
    dlmm: 'Password',
    qsrmm: 'Enter password',
    mmcd: 'Password must be at least 6 characters',
    qrmm: 'Confirm Password',
    qzcsrmm: 'Re-enter password',
    lcsrdmmbyz: 'Passwords do not match',
    yzm: 'Verification Code',
    qsryzm: 'Enter verification code',
    yzmcd: 'Code must be 6 characters',
    zc: 'Sign Up',
    yyzh: 'Already have an account?',
    qdl: 'Log In',
    hqyzm: 'Get Code',
    fscg: 'Email sent! Check your inbox.',
    fscgts: 'Sent',
    cxhq: 'Resend Code',
    hqyzm: 'Get Code',
  },
  SCV: {
    jbxx: 'Profile',
    xm: 'Name',
    nl: 'Age',
    lxfs: 'Contact Info',
    xb: 'Gender',
    sg: 'Height',
    tz: 'Weight',
    xl: 'Heart Rate',
    zy: 'Occupation',
    sfz: 'ID Number',
    qx: 'Cancel',
    jzl: 'Worsened',
    jql: 'Improved',
    xsl: 'Disappeared',
    zzjz: 'Loading',
    zztj: 'Submitting',
    fkcg: 'Feedback Sent',
    tjfkccl: 'Failed to Submit Feedback',
    zzhqsj: 'Loading',
    zzclsj: 'Processing',
  },
  UPI: {
    changePassword: "Change Password",
    oldPassword: "Old Password",
    enterOldPassword: "Enter old password",
    oldPasswordEmpty: "Old password cannot be empty",
    newPassword: "New Password",
    enterNewPassword: "Enter new password",
    newPasswordEmpty: "New password cannot be empty",
    passwordMinLength: "Password must be at least 6 characters",
    confirmPassword: "Confirm New Password",
    reEnterNewPassword: "Re-enter new password",
    confirmPasswordEmpty: "Confirm new password cannot be empty",
    passwordMismatch: "Passwords do not match",
    save: "Save",
    updating: "Updating",
    updateSuccess: "Password changed successfully",
    updateFail: "Failed to change password"
  },
  PIV: {
    modifyInfo: "Modify Information",
    fullName: "Full Name",
    enterFullName: "Please enter your full name",
    age: "Age",
    enterAge: "Please enter your age",
    gender: "Gender",
    selectGender: "Please select your gender",
    male: "Male",
    female: "Female",
    height: "Height (cm)",
    enterHeight: "Please enter your height",
    occupation: "Occupation",
    enterOccupation: "Please enter your occupation",
    phone: "Contact Info",
    enterPhone: "Please enter your contact info",
    weight: "Weight (kg)",
    enterWeight: "Please enter your weight",
    save: "Save",
    saving: "Saving",
    updateSuccess: "Update successful",
    updateFail: "Update failed, please try again!",
    nameRequired: "You must enter your full name",
    phoneRequired: "You must enter your contact info",
    invalidAge: "Please enter your age as a number",
    invalidHeight: "Please enter your height as a number, in centimeters",
    invalidWeight: "Please enter your weight as a number, in kilograms"
  },
  SRL: {
    signalRecords: "Signal Records",
    diagnosing: "Diagnosing",
    viewSignal: "View Signal",
    viewPrescription: "View",
    feedback: "Feedback",
    again: 'Diagnose Again',
    loginRequiredTitle: "Notice",
    loginRequiredMessage: "This feature requires you to log in.",
    goToLogin: "Go to Login",
    noMoreData: "No more data",
    pullRefreshText: "Release to refresh",
    loadingText: "Loading..."
  },
  UFB: {
    userFeedback: "User Feedback",
    loading: "Loading",
    submittingFeedback: "Submitting Feedback",
    feedbackSuccess: "Feedback submitted successfully",
    feedbackError: "Failed to submit feedback",
    editFeedback: "Edit Feedback",
    deleteFeedback: "Delete This Item",
    saveChanges: "Save Changes",
    savingChanges: "Saving Changes",
    editSuccess: "Edit successful",
    editError: "Failed to edit feedback",
    deleteSuccess: "Delete successful",
    deleteError: "Failed to delete feedback",
    typeFeedbackPlaceholder: "Type your feedback here",
    editFeedbackPlaceholder: "Edit feedback content",
    savingChanges: "Saving Changes",
    deleting: "Deleting",
    feedbackEmpty: "Feedback cannot be empty",
  },
  SRD: {
    prescription: "Prescription",
    diagnosisAnalysis: "Symptom signal analysis",
    consultantNotes: "Notes",
    prescriptionDetails: "Herbs",
    cg: 'Total ',
    cw: ' herbs',
    cf0: ' dose',
    cf: ' doses',
    cmr: ' daily',
    crf: '',
    cc: 'times daily',
    hz: 'Subsequent visit',
  },
  GYY: {
    jz: 'Public donations and assistance',
  },
  WDGW: {
    sb: 'Failed to obtain the consultant list!',
    sb1: 'Failed to change the consultant!',
    cg: 'Successfully',
  },
  ABO: {
    aboutAs: 'About Us',
  }
}
